export const blockTypesRecord = {
  // layout
  root: 'root',
  document: 'document',
  list: 'list',
  component: 'component',
  instance: 'instance',
  // primitive
  text: 'text',
  icon: 'icon',
  select: 'select',
  reference: 'reference',
  number: 'number',
  comment: 'comment',
  richText: 'rich-text',
  media: 'media',
  boolean: 'boolean',
  date: 'date',
  codeSnippet: 'code-snippet',
  color: 'color',
  ogImage: 'og-image',
  // generic
  variantSet: 'variant-set',
  event: 'event',
  workflow: 'workflow',
  agent: 'agent',
  // extend: 'extend',
  // omit: 'omit',
} as const

export type BlockTypes =
  (typeof blockTypesRecord)[keyof typeof blockTypesRecord]

export const prettifyBlockType = (key: string) => {
  if (key === 'list') return 'Collection'
  if (key === 'og-image') return 'OG Image'
  return key
    .replace(/-([a-z])/g, (_, c) => ' ' + c.toUpperCase())
    .replace(/^\w/, (c) => c.toUpperCase())
}
